<template>
  <div class="notificationContainer">
    <v-slide-y-reverse-transition group>
      <v-alert v-for="(snackBar) in snackBars.slice().reverse()" v-if="snackBar.show" :key="snackBar.id"
               :color="snackBar.color" :min-width="500" border="left" colored-border
               dismissible @input="closeSnackBar(snackBar.id)">
        <template v-slot:prepend>
          <v-icon :color="snackBar.color" class="pr-6">{{ snackBar.icon }}</v-icon>
        </template>
        <span>{{ snackBar.message }}</span>
      </v-alert>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
import {EventBus} from "@/lib/event-bus";
import {EVENTBUS_TOPICS} from "@/lib/constants";

export default {
  name: "user-action-result-popup",
  data() {
    return {
      snackBars: [],
      nextId: 1
    };
  },
  methods: {
    closeSnackBar(id) {
      this.removeSnackBar(id);
    },
    addSnackBar(actionResultDetails) {
      const snackBar = {
        id: this.nextId++,
        message: actionResultDetails.message,
        icon: actionResultDetails.isSuccess ? 'mdi-check-circle' : 'mdi-alert-circle',
        color: actionResultDetails.isSuccess ? 'green' : 'red',
        show: true
      };
      this.snackBars.push(snackBar);
      setTimeout(() => {
        this.removeSnackBar(snackBar.id);
      }, 6000);
    },
    removeSnackBar(id) {
      const index = this.snackBars.findIndex(snackBar => snackBar.id === id);
      if (index !== -1) {
        this.snackBars.splice(index, 1);
      }
    }
  },
  mounted() {
    EventBus.$on(EVENTBUS_TOPICS.USER_ACTION_FEEDBACK, this.addSnackBar);
  },
  beforeDestroy() {
    EventBus.$off(EVENTBUS_TOPICS.USER_ACTION_FEEDBACK);
  }
};
</script>

<style scoped>
.notificationContainer {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  grid-gap: 0.5em;
  z-index: 99;
}
</style>
